import React from "react";
import CardTemplate from "./CardTemplate";
import styled from "styled-components";

interface Props {
	coaStatus: string;
}

const Coa = ({ coaStatus }: Props) => {
	return (
		<CardTemplate title="COA">
			<Container>
				<BoldText>Status</BoldText>
				{coaStatus === "Accepted" ? (
					<Status>{"Accepted"}</Status>
				) : (
					<Status>{"Not yet accepted"}</Status>
				)}
			</Container>
		</CardTemplate>
	);
};

const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1px;
`;

const BoldText = styled.div`
	font-weight: 700;
	display: inline;
`;

const Status = styled.div`
	font-weight: 400;
	display: inline;
`;

export default Coa;
